import React from 'react';
import { AppState, DateTime } from 'acscp/store';
import { FormattedMessage } from 'react-intl';
import { LocaleCode } from 'acscp/translations';
import { connect } from 'react-redux';

interface LocalTimeWithFallbackProps {
    dateTime: DateTime;
    fallback?: React.ReactNode;
}

interface InjectedStateProps {
    locale: LocaleCode;
}

const LocalTimeWithFallbackForLocale: React.SFC<LocalTimeWithFallbackProps & InjectedStateProps> = ({dateTime, fallback, locale}) => {

    const time = dateTime.getLocallyFormattedTime(locale);
    if (time != null) {
        return <span>{time}</span>;
    }

    if (!fallback) {
        fallback = (
            <FormattedMessage
                id={'components.common.localTimeWithFallback.defaultFallback'}
                defaultMessage={'To be confirmed'}
            />
        );
    }
    return <span>{fallback}</span>;
};

function mapStateToProps(state: AppState): InjectedStateProps {
    return {
        locale: state.intl.locale
    };
}

export const LocalTimeWithFallback = connect(mapStateToProps)(LocalTimeWithFallbackForLocale);
